import React from "react";
import { View, TouchableWithoutFeedback } from "react-native";
import Text from "@components/CustomText";

const CTAButton = ({
  btnTextColor,
  btnStyle = {},
  btnText,
  width,
  activeBtnStyle = {},
  activeBtnTextColor = "",
  active = false,
  onPress = () => {},
}) => (
  <TouchableWithoutFeedback onPress={onPress}>
    <View
      style={[
        {
          paddingVertical: 13,
          borderRadius: 6,
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
        },
        {
          width,
        },
        active ? activeBtnStyle : btnStyle,
      ]}
    >
      <Text
        // variant={active ? "body_text_4" : "body_text_3"}
        variant="body_text_4"
        style={{ color: active ? activeBtnTextColor : btnTextColor }}
      >
        {btnText}
      </Text>
    </View>
  </TouchableWithoutFeedback>
);

export default CTAButton;
